module.exports = __webpack_public_path__ + "57f97b8f47de2af1c0cdba9bb75498e7.pdf";